// Simple client-side article search — matches on fields already present in
// the article data returned by the existing list endpoints. No backend
// search system, no new collection; reused across WIM Blog, Care News and
// the Advantage Series listing.
export function articleMatchesSearch(item, query, fields = ["title"]) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => String(item[f] || "").toLowerCase().includes(q));
}
